import React, { Component } from "react";
import { TextField } from "reactackle";
import { IconSvg } from "reactackle-icons";
import { Button } from "reactackle";

class SubGridVanillaMobile extends Component {
  state = {
    selectedIndexes: []
  };
  getRowCount = () => {
    ////console.log("Data Length: " + this.props.data.length);
    if (this.props.data && this.props.data.length > 0) {
      return this.props.data.length;
    } else {
      return 0;
    }
  };

  getDataWithEmptyRow = singleRow => {
    let empRow = {};
    for (let key in singleRow) {
      empRow[key] = "";
    }
    this.props.data.push(empRow);
    return this.props.data;
  };

  rowGetter = i => {
    ////console.log("Sending Row: " + JSON.stringify(this.props.data[i]));
    if (this.props.data && this.props.data.length > 0) {
      return { ...this.props.data[i] };
    }
  };

  onRowsSelected = rows => {
    this.setState({
      selectedIndexes: this.state.selectedIndexes.concat(
        rows.map(r => r.rowIdx)
      )
    });
  };

  onRowsDeselected = rows => {
    let rowIndexes = rows.map(r => r.rowIdx);
    this.setState({
      selectedIndexes: this.state.selectedIndexes.filter(
        i => rowIndexes.indexOf(i) === -1
      )
    });
  };

  deleteSelected = () => {
    if (this.props.data && this.props.data.length < 2) {
      alert("Not enough items to be deleted");
    } else {
      let oldArray = this.props.data;
      let newArray = [];
      for (let i = 0; i < this.props.data.length - 1; i++) {
        if (!this.state.selectedIndexes.includes(i)) {
          newArray.push(oldArray[i]);
        }
      }

      this.props.stateChangeHandler(
        newArray,
        this.props.fieldName,
        this.props.isPayload
      );
    }
  };

  addRows = () => {
    console.log("adding rows...");
    let newArray = [];
    if (this.props.data && this.props.data.length > 0) {
      newArray = this.props.data.map(item => item);
      newArray.push(this.props.emptyRow);
    } else {
      newArray.push(this.props.emptyRow);
    }
    //console.log(JSON.stringify(newArray));
    this.props.stateChangeHandler(
      newArray,
      this.props.fieldName,
      this.props.isPayload
    );
  };

  doCalc = (val1, val2, strOperator) => {
    // console.log(
    //   "in doCalc, recvd val1:" +
    //     val1 +
    //     " " +
    //     " val2:" +
    //     val2 +
    //     " operator:" +
    //     strOperator
    // );
    let result = "0";
    if (
      val1 === "" ||
      val2 === "" ||
      val1 === undefined ||
      val1 === null ||
      val2 === undefined ||
      val2 === null
    ) {
      return result;
    }

    let num1 = parseFloat(val1);
    let num2 = parseFloat(val2);
    if (!isNaN(num1) && !isNaN(num2)) {
      // console.log(
      //   "All good about to do calc " + num1 + "  " + strOperator + "  " + num2
      // );
      if (strOperator === "*") {
        return num1 * num2;
      } else if (strOperator === "+") {
        return num1 + num2;
      } else if (strOperator === "-") {
        return num1 - num2;
      } else if (strOperator === "/") {
        return num1 / num2;
      } else {
        return result;
      }
    } else {
      return result;
    }
  };

  executeCalc = (calcRule, data, rowNum) => {
    calcRule = calcRule.replace(" ", "");
    calcRule = calcRule.replace(/\*/g, " * ");
    calcRule = calcRule.replace(/\+/g, " + ");
    calcRule = calcRule.replace(/-/g, " - ");
    calcRule = calcRule.replace(/\//g, " / ");
    let calcRuleArray = calcRule.split(" ");
    //console.log("calcRule array: " + JSON.stringify(calcRuleArray));
    let res = this.doCalc(
      data[calcRuleArray[0]],
      data[calcRuleArray[2]],
      calcRuleArray[1]
    );

    //console.log("Here is the res: " + res);
    return res;
  };

  updateCalcValues = (tmpData, fieldDefs, rowNum) => {
    // console.log(
    //   "Updating calc values: " +
    //     JSON.stringify(tmpData) +
    //     " defs: " +
    //     JSON.stringify(fieldDefs)
    // );
    for (let key in fieldDefs) {
      let fieldDets = fieldDefs[key];
      if (fieldDets.mode && fieldDets.mode === "calc") {
        //console.log("Key is: " + fieldDets.key);
        tmpData[rowNum][fieldDets.key] = this.executeCalc(
          fieldDets.rule,
          tmpData[rowNum]
        );
      }
    }
    //console.log("Updated tmpData is: " + JSON.stringify(tmpData));
    return tmpData[rowNum];
  };

  onGridRowsUpdated = (fromRow, toRow, updated, tableDef) => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
    if (updated && updated !== undefined) {
      let key = Object.keys(updated);
      let tmpData = JSON.parse(JSON.stringify(this.props.data));
      //console.log("Before: " + JSON.stringify(tmpData[fromRow]));
      tmpData[fromRow][key] = updated[key];
      tmpData[fromRow] = this.updateCalcValues(tmpData, tableDef, fromRow);
      //console.log("After: " + JSON.stringify(tmpData));
      this.props.stateChangeHandler(
        tmpData,
        this.props.fieldName,
        this.props.isPayload
      );
    }
  };

  getCellValue = (fldName, fldValue, rowNum, tableDef, rec) => {
    //console.log(
    //   "getCellValue: fldname: " +
    //     fldName +
    //     "  fldValue: " +
    //     fldValue +
    //     " rowNum:" +
    //     rowNum
    // );
    if (typeof jsonValue !== "object") {
      return (
        <TextField
          bordered
          value={fldValue}
          resize="auto"
          placeholder={fldName}
          multiline={fldName === "description" ? true : false}
          multilineRows={{ min: fldName === "description" ? 6 : 1 }}
          disabled={rec.disabled}
          onChange={val => {
            //console.log("Value from text field: " + JSON.stringify(val));
            let updatedObj = {};
            updatedObj[fldName] = val.value;
            //console.log(
            //   "updated value: " +
            //     JSON.stringify(updatedObj) +
            //     " rowNum: " +
            //     rowNum
            // );
            this.onGridRowsUpdated(rowNum, rowNum, updatedObj, tableDef);
          }}
          style={{ margin: "0px", padding: "0px" }}
        />
      );
    }
  };

  getColumns = (rowNum, jObject, tableDef) => {
    //console.log("jObject: " + JSON.stringify(jObject));
    //console.log("rowNum: " + rowNum);
    //console.log("tableDef: " + JSON.stringify(tableDef));
    return tableDef.map((rec, index) => {
      return this.getCellValue(
        rec.key,
        jObject[rec.key],
        rowNum,
        tableDef,
        rec
      );
    });
  };

  getDelIcon = rowIndex => {
    return (
      <a
        onClick={() => {
          this.onGridRowsDeleted(rowIndex);
        }}
      >
        <IconSvg>
          <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
            />
          </svg>
        </IconSvg>
      </a>
    );
  };
  getUpIcon = () => {
    return (
      <div
        className="col-sm-2"
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <IconSvg>
          <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
            />
          </svg>
        </IconSvg>
      </div>
    );
  };
  getDownIcon = () => {
    return (
      <div
        className="col-sm-2"
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <IconSvg>
          <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
            />
          </svg>
        </IconSvg>
      </div>
    );
  };
  getPlusIcon = rowIndex => {
    return (
      <a
        href="_"
        onClick={event => {
          event.preventDefault();
          this.onGridRowsAdded(rowIndex);
        }}
      >
        <IconSvg>
          <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
            />
          </svg>
        </IconSvg>
      </a>
    );
  };

  onGridRowsAdded = rowNum => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));

    let tmpData = JSON.parse(JSON.stringify(this.props.data));
    //console.log("Before: " + JSON.stringify(tmpData));
    tmpData.splice(rowNum + 1, 0, this.props.emptyRow);

    //console.log("After: " + JSON.stringify(tmpData));
    this.props.stateChangeHandler(
      tmpData,
      this.props.fieldName,
      this.props.isPayload
    );
  };

  onGridRowsDeleted = rowNum => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));

    let tmpData = JSON.parse(JSON.stringify(this.props.data));
    //console.log("Before: " + JSON.stringify(tmpData));
    delete tmpData[rowNum];

    tmpData = tmpData.filter(item => item !== null);
    //console.log("at filter:" + JSON.stringify(currActionsList));

    //console.log("After: " + JSON.stringify(tmpData));
    this.props.stateChangeHandler(
      tmpData,
      this.props.fieldName,
      this.props.isPayload
    );
  };

  getRows = data => {
    if (data && data !== undefined && data.length > 0) {
      return data.map((rec, rowNum) => {
        return (
          <div
            style={{
              margin: "5px",
              padding: "5px",
              borderColor: "grey",
              borderStyle: "solid",
              borderWidth: "0.25px"
            }}
          >
            {this.getColumns(rowNum, rec, this.props.colDefs)}
            <div
              style={{
                margin: "5px",
                height: "45px"
              }}
            >
              <div
                className="col-sm-2"
                style={{
                  padding: "10px",
                  textAlign: "center",
                  border: "1px solid gainsboro",
                  height: "45px",
                  width: "45px",
                  marginRight: "5px",
                  float: "right"
                }}
              >
                {this.getPlusIcon(rowNum)}
              </div>
              <div
                style={{
                  padding: "10px",
                  textAlign: "center",
                  border: "1px solid gainsboro",
                  height: "45px",
                  width: "45px",
                  float: "right",
                  marginLeft: "5px"
                }}
              >
                {this.getDelIcon(rowNum)}
              </div>
            </div>
          </div>
        );
      });
    }
  };

  getVanillaGrid = () => {
    console.log(JSON.stringify(this.props.data));
    return (
      <div>
        <hr />
        <h3 style={{ textAlign: "left" }}>{this.props.caption}</h3>
        <div>{this.getRows(this.props.data)}</div>

        <div
          style={{
            display: "flex",
            flexDirection: "row-reverse",
            padding: "0px"
          }}
        >
          <div sytle={{ float: "right" }}>
            <Button
              text="Add"
              className="flat"
              style={{ padding: "0px", margin: "0px" }}
              onPress={() => this.addRows()}
            />
            <Button
              text="Delete"
              className="flat"
              style={{ padding: "0px", margin: "0px" }}
              onPress={() => this.deleteSelected()}
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    return <div>{this.getVanillaGrid()}</div>;
  }
}

export default SubGridVanillaMobile;



// WEBPACK FOOTER //
// ./src/app/components/Screens/SubGrid/SubGridVanillaMobile.jsx